"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var interface_date_1 = require("@uip-alpha/interface-date");
var shared_utils_1 = require("@uip-alpha/shared-utils");
var DAY_MILLISECONDS = 24 * 60 * 60 * 1000;
var date = function (UIP) { return ({
    /**
     * 标准化日期字符串，返回Date对象
     * @param date DateStr
     * @param returnStr 是否只返回字符串格式，不转为Date对象
     */
    normalizeDate: function (date, returnStr) {
        if (returnStr === void 0) { returnStr = false; }
        if (typeof date === 'string') {
            if (returnStr)
                return date.replace(/-/g, '/');
            date = this.getDate(date);
        }
        return date;
    },
    /**
     * 格式化日期时间
     * @param date 日期时间对象
     * @param formatStr 目标格式化格式
     */
    formatDate: function (date, formatStr) {
        if (date === void 0) { date = new Date(); }
        if (formatStr === void 0) { formatStr = 'yyyy-MM-dd hh:mm:ss'; }
        var _date = this.normalizeDate(date);
        var paddNum = function (num) { return String(num).replace(/^(\d)$/, '0$1'); };
        // 指定格式字符
        var cfg = {
            yyyy: _date.getFullYear(),
            yy: _date
                .getFullYear()
                .toString()
                .substring(2),
            M: _date.getMonth() + 1,
            MM: paddNum(_date.getMonth() + 1),
            d: _date.getDate(),
            dd: paddNum(_date.getDate()),
            hh: paddNum(_date.getHours()),
            mm: paddNum(_date.getMinutes()),
            ss: paddNum(_date.getSeconds()),
            SSS: paddNum(_date.getMilliseconds()) // 毫秒
        };
        return formatStr.replace(/([a-z])(\1)*/gi, function (m) { return cfg[m]; });
    },
    /**
     * 从格式化字符串中获取Date对象
     * @param formatedDate 已经格式化后的date字符串
     */
    getDate: function (formatedDate) {
        if (formatedDate === void 0) { formatedDate = ''; }
        if (/^\d{4}(\/|-)\d{2}(\/|-)\d{2}/g.test(formatedDate))
            return new Date(Date.parse(formatedDate.replace(/-/g, '/')));
        return new Date();
    },
    /**
     * 获取日期时间戳
     * @param formatedDate 已经格式化后的date字符串
     */
    getDateStamp: function (formatedDate) {
        if (formatedDate === void 0) { formatedDate = ''; }
        return this.getDate(formatedDate).getTime();
    },
    /**
     * 获取服务器时间
     * @param area 当前服务器所在地区
     * @return Date对象
     */
    now: function () {
        return __awaiter(this, void 0, void 0, function () {
            var date;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, UIP.interface.date.getServerTime()];
                    case 1:
                        date = _a.sent();
                        return [2 /*return*/, this.getDate(String(date))];
                }
            });
        });
    },
    /**
     * 官网获取服务时间
     */
    nowOwf: function () {
        return __awaiter(this, void 0, void 0, function () {
            var date;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, UIP.interface.date.getServerTimeOwf()];
                    case 1:
                        date = _a.sent();
                        return [2 /*return*/, this.getDate(String(date))];
                }
            });
        });
    },
    /**
     * 计算目标日期今天后天明天或者具体月份日期
     * @param dstDate 目标日期
     * @param nowTime 当前日期
     * @param showMonth 是否显示月份
     * @param showDay 是否只显示月份日期，不显示今天昨天明天
     */
    dateToDay: function (dstDate, nowTime, showMonth, showDay) {
        if (nowTime === void 0) { nowTime = new Date(); }
        if (showMonth === void 0) { showMonth = false; }
        if (showDay === void 0) { showDay = false; }
        var _dstDate = this.normalizeDate(dstDate);
        var nowStamp = this.getDateStamp(this.formatDate(nowTime, 'yyyy-MM-dd'));
        var dstDateStamp = this.getDateStamp(this.formatDate(_dstDate, 'yyyy-MM-dd'));
        var during = Math.ceil(dstDateStamp - nowStamp) / DAY_MILLISECONDS;
        var monthDay = "" + ((showMonth && _dstDate.getMonth() + 1 + '月') || '') + _dstDate.getDate() + "\u65E5";
        return ((showDay && monthDay) ||
            {
                2: '后天',
                1: '明天',
                0: '今天',
                '-1': '昨天',
                '-2': '前天'
            }[String(during)] ||
            monthDay);
    },
    /**
     * 计算N天后或N天前的日期
     * @param n 天数
     * @param startDate 起始日期
     * @param formatStr 目标格式化格式
     */
    dateAddN: function (n, startDate, formatStr) {
        if (startDate === void 0) { startDate = new Date(); }
        if (formatStr === void 0) { formatStr = 'yyyy-MM-dd'; }
        var date = startDate;
        if (typeof startDate === 'string')
            date = this.getDate(startDate);
        return this.formatDate(new Date(date.getTime() + DAY_MILLISECONDS * n), formatStr);
    },
    /**
     * 计算当前服务器时间N天后或N天前的日期
     * @param n 天数
     * @param formatStr 目标格式化格式
     */
    dateServerAddN: function (n, formatStr) {
        if (formatStr === void 0) { formatStr = 'yyyy-MM-dd'; }
        return __awaiter(this, void 0, void 0, function () {
            var serverDate;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.now()];
                    case 1:
                        serverDate = _a.sent();
                        return [2 /*return*/, this.dateAddN(n, serverDate, formatStr)];
                }
            });
        });
    },
    /**
     * 根据今天后天明天计算具体日期
     * @param desc 日期描述：今天后天明天
     * @param nowTime 当前日期
     * @param formatStr 目标格式化格式
     */
    dayToDate: function (desc, nowTime, formatStr) {
        if (desc === void 0) { desc = '今天'; }
        if (nowTime === void 0) { nowTime = new Date(); }
        if (formatStr === void 0) { formatStr = 'yyyy-MM-dd'; }
        var n = {
            后天: 2,
            明天: 1,
            今天: 0,
            昨天: -1,
            前天: -2
        }[desc] || 0;
        return this.dateAddN(n, nowTime, formatStr);
    },
    /**
     * 当前系统时间是否在配置时间范围内
     * @param  startT    开始时间 yyyy/MM/dd hh:mm:ss
     * @param  endT      结束时间 yyyy/MM/dd hh:mm:ss
     * @param  storageKey     session存储的key
     */
    isTimeframe: function (startT, endT, storageKey) {
        var _this = this;
        if (startT === void 0) { startT = ''; }
        if (endT === void 0) { endT = ''; }
        if (storageKey === void 0) { storageKey = 'config_time_ishow'; }
        var timeConfig = UIP.sessionStorage.get(storageKey) || '';
        if (timeConfig)
            return Promise.resolve(timeConfig === 'YES');
        return this.now()
            .then(function (date) {
            if (date && startT && endT) {
                var curTime = date.getTime();
                var startTime = _this.getDateStamp(startT);
                var endTime = _this.getDateStamp(endT);
                if (curTime > startTime && curTime < endTime) {
                    UIP.sessionStorage.set(storageKey, 'YES');
                    return true;
                }
                UIP.sessionStorage.set(storageKey, 'NO');
                return false;
            }
        })
            .catch(function () {
            return false;
        });
    },
    /**
     * 获取小时数
     * @param time 只有小时、分钟的时间格式
     */
    getHours: function (time) {
        var date = time.match(/\d{2}/g) || [];
        return Number(date[0] || 0);
    },
    /**
     * 获取分钟数
     * @param time 只有小时、分钟的时间格式
     */
    getMinutes: function (time) {
        var date = time.match(/\d{2}/g) || [];
        return Number(date[1] || 0);
    },
    /**
     * 分钟数格式化，80 => '01:20'
     * @param minutes 分钟数
     */
    minutesToHM: function (minutes) {
        var HH = Math.floor(minutes / 60);
        // 超过24点的取24的余数
        if (HH > 23)
            HH = HH % 24;
        var MM = minutes % 60;
        return (HH < 10 ? '0' + HH : HH) + ':' + (MM < 10 ? '0' + MM : MM);
    },
    /**
     * 返回所需的分钟数或秒数
     * @param hours 小时
     * @param minutes 分钟
     * @param second 秒
     */
    getMinutesOrSecond: function (hours, minutes, second) {
        if (minutes === void 0) { minutes = 0; }
        if (second === void 0) { second = 0; }
        var getTime = 0;
        // 将小时数转换为分钟数
        if (hours)
            getTime = hours * 60;
        // 加上现在所在的分钟
        if (minutes)
            getTime += minutes;
        // 如果有秒将时间转为秒
        if (second)
            getTime = getTime * 60 + second;
        return getTime;
    },
    /**
     * 将分钟数转换为小时，小时向上取整，再转换为分钟数
     * @param minutes
     */
    ceilHours: function (minutes) {
        return Math.ceil(minutes / 60) * 60;
    },
    /**
     * 将分钟数转换为小时，小时向下取整，再转换为分钟数
     * @param minutes
     */
    floorHours: function (minutes) {
        return Math.floor(minutes / 60) * 60;
    },
    /**
     * 将总的分钟数转换为小时，将小时数向上取整再装换为分钟
     * @param hours
     * @param minutes
     * @param addMinutes  标识是否需要向后多加几个个钟
     */
    getCeilMinutes: function (hours, minutes, addMinutes) {
        if (minutes === void 0) { minutes = 0; }
        if (addMinutes === void 0) { addMinutes = 0; }
        if (addMinutes && hours !== 24) {
            hours += addMinutes / 60;
            minutes = 0;
        }
        return this.ceilHours(this.getMinutesOrSecond(hours, minutes));
    },
    /**
     * 将字符串格式的时间转换为小时、分钟
     * 将小时数向上取整再装换为分钟
     * @param stringTime 字符串的时间格式
     * @param addMinutes  标识是否需要向后多加几个个钟
     */
    getStringTimeCeilMinutes: function (stringTime, addMinutes) {
        if (addMinutes === void 0) { addMinutes = 0; }
        var hours = this.getHours(stringTime);
        var minutes = this.getMinutes(stringTime);
        return this.getCeilMinutes(hours, minutes, addMinutes);
    },
    /**
     * 用户展示今天的第一个时间段
     * @param interval
     */
    getShowTime: function (interval) {
        var firstT = new Map([[60, '一小时内'], [30, '半小时内'], [15, '一刻钟内']]).get(interval) || interval + '分钟内';
        return firstT;
    }
}); };
exports.default = {
    name: 'utils-date',
    install: function (UIP) {
        if (!shared_utils_1.beforeInit(UIP)('storage'))
            return;
        UIP.use(interface_date_1.default);
        UIP.checkModule('utils', 'date');
        UIP.utils.date = date(UIP);
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/utils-date/dist/index.js
// module id = D9Q8
// module chunks = 1